import React from "react"
import { Container } from "react-bootstrap"
import // navigateToSupportingDocument,
// navigateToClaimantDetail,
// navigateToEmployerDetail,
// navigateToOtherPolicies,
// navigateToPaymentDetail,
"../../common/function"
import { useSelector } from "react-redux"
// import { updateUiData } from "../../redux/actions"

const EtiqaHeader = ({ logo, claimFormTitle }) => {
  const uiData = useSelector(state => state.uiData) // Cannot remove this
  const { pageNumber } = uiData

  // const dispatch = useDispatch()

  const getStatusClassname = thisSectionPageNumber => {
    // let pathName = window.location.pathname
    let className
    const startCombineSectionPageNumber = 3
    const pageNumberAfterCombineSection = 5

    switch (thisSectionPageNumber) {
      case startCombineSectionPageNumber:
        if (pageNumber >= pageNumberAfterCombineSection) {
          className = "tick"
        } else if (
          pageNumber >= thisSectionPageNumber &&
          pageNumber < pageNumberAfterCombineSection
        ) {
          className = "current"
        } else {
          className = ""
        }
        break
      default:
        if (pageNumber > thisSectionPageNumber) {
          className = "tick"
        } else if (pageNumber === thisSectionPageNumber) {
          className = "current"
        } else {
          className = ""
        }
        break
    }

    return className
  }

  return (
    <>
      <div className="header">
        <Container>
          <div id="top" className="headNav">
            <nav className="js-nav or--active navNew">
              <div className="logo">
                <a href="https://www.etiqa.com.sg" className="link-home">
                  <img src={logo} alt="Etiqa Logo"></img>
                </a>
              </div>
              <div className="navigate d-block"></div>
            </nav>
          </div>
        </Container>
      </div>
    </>
  )
}
export default EtiqaHeader
